import { useEffect, useState } from 'react';
import { TwAutocompleteOption } from '../components/TwAutocomplete/TwAutocomplete';
import { caPortCodesRaw, usPortCodesRaw } from '../utils/location/variables';

export const usePortCodeOptions = (): {
  usPorts: TwAutocompleteOption[];
  caPorts: TwAutocompleteOption[];
} => {
  const [usPorts, setUsPorts] = useState<TwAutocompleteOption[]>([]);
  const [caPorts, setCaPorts] = useState<TwAutocompleteOption[]>([]);

  useEffect(() => {
    const usPorts = usPortCodesRaw.map((port) => {
      const label = `${port.code} - ${port.portOfEntry}`;
      return { id: port.code, value: port.code, label };
    });

    const caPorts = caPortCodesRaw.map((port) => {
      const label = `${port.number} - ${port.name}`;
      return { id: port.number, value: port.number, label };
    });

    setUsPorts(usPorts);
    setCaPorts(caPorts);
  }, []);

  return { usPorts, caPorts };
};
